import PropTypes from 'prop-types';
import { uiFriendlyRolesAccessors } from '../../../../constants/uiFriendlyRoles';

const NextActionByCell = ({ cell: { value } }) => (
  <div>{value && <span>{uiFriendlyRolesAccessors(value)}</span>}</div>
);

NextActionByCell.propTypes = {
  cell: PropTypes.object.isRequired,
};

export { NextActionByCell };
